import { render } from "./SuperAdminSelection.vue?vue&type=template&id=72df550c&scoped=true"
import script from "./SuperAdminSelection.vue?vue&type=script&lang=js"
export * from "./SuperAdminSelection.vue?vue&type=script&lang=js"

import "./SuperAdminSelection.vue?vue&type=style&index=0&id=72df550c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72df550c"]])

export default __exports__